export default "__VITE_PUBLIC_ASSET__df690833__"